<div *ngIf="mode === 'view'" class="field field_size_{{ size ? size : 'l' }}">
  <div class="field__name">{{ name ? name : ('components.fieldWebDocument.labels.document' | translate) }} &nbsp;</div>
  <div class="field__value">
    <app-link [url]="value" [displayText]="'components.fieldWebDocument.buttons.look' | translate"></app-link>
  </div>
</div>
